import { render, staticRenderFns } from "./_cmdSBOMatch.vue?vue&type=template&id=87960214&scoped=true&lang=pug&"
import script from "./_cmdSBOMatch.vue?vue&type=script&lang=js&"
export * from "./_cmdSBOMatch.vue?vue&type=script&lang=js&"
import style0 from "./_cmdSBOMatch.vue?vue&type=style&index=0&id=87960214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87960214",
  null
  
)

export default component.exports